/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationprizevalueformat4Inputs */

const en_dropvalidationprizevalueformat4 = /** @type {(inputs: Dropvalidationprizevalueformat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid amount, e.g. 149.00`)
};

const de_dropvalidationprizevalueformat4 = /** @type {(inputs: Dropvalidationprizevalueformat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte einen gültigen Betrag eingeben, z. B. 149.00`)
};

/**
* | output |
* | --- |
* | "Enter a valid amount, e.g. 149.00" |
*
* @param {Dropvalidationprizevalueformat4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationprizevalueformat4 = /** @type {((inputs?: Dropvalidationprizevalueformat4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationprizevalueformat4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationprizevalueformat4(inputs)
	return de_dropvalidationprizevalueformat4(inputs)
});
export { dropvalidationprizevalueformat4 as "dropValidationPrizeValueFormat" }